/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { ActivatedRouteSnapshot } from '@angular/router';

import { AddToPendingService } from './services/add-to-pending.service';
import { ConfigService } from './../../core/services/config.service';
import { Injectable } from '@angular/core';
import { LmsEventDetails } from './../../core/model/lms-event-details.model';
import { LmsLoaderService } from './../../core/services/lms-loader.service';
import { Tab } from '../../core/model/tab.model';
import { TabService } from './../../core/services/tab.service';
import { TerminalStatusService } from './services/terminal-status.service';

/**
 * @export
 * @class TerminalStatusResolver
 * @implements {Resolve<Tab>}
 */
@Injectable()
export class TerminalStatusResolver  {

    /**
     * Creates an instance of TerminalStatusResolver.
     * @param {TabService} tabService
     * @param {TerminalStatusService} terminalStatusService
     * @param {ConfigService} configService
     * @param {AddToPendingService} addToPendingService
     * @param {LmsLoaderService} lmsLoaderService
     *
     * @memberOf TerminalStatusResolver
     */
    constructor(
        private tabService: TabService,
        private terminalStatusService: TerminalStatusService,
        private configService: ConfigService,
        private addToPendingService: AddToPendingService,
        private lmsLoaderService: LmsLoaderService
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        this.addToPendingService.resetAll();
        let tab = this.tabService.getTabById(Math.abs(route.params['tabid']))[0];
        let tabType = this.configService.getConfigData().tab.event.update;
        if (!tab) {
            tabType = this.configService.getConfigData().tab.event.add;
            tab = {
                tabSearchParameter: {
                    searchText: (route.queryParams['search'] ? route.queryParams['search'] : ''), noThroughTrains: ((route.queryParams['noThroughTrains']
                        && route.queryParams['noThroughTrains'] !== 'undefined' && route.queryParams['noThroughTrains'] !== 'false') ? 'Y' : ''), spinnerVal:
                        (route.queryParams['spinnerVal'] ? route.queryParams['spinnerVal'] : '')
                }, description: '', locateLocoId: route.queryParams['locateLocoId']
            };
        }
        if (!(tab.subTypeDetail && tab.subTypeDetail.status && tab.subTypeDetail.status.status)) {
            if (!tab.subTypeDetail) {
                tab.subTypeDetail = {};
            }
            tab.subTypeDetail['status'] = {
                message: '',
                status: 'blank'
            };
        }

        if (tab.tabSearchParameter && tab.tabSearchParameter.searchText) {
            if ((tabType === this.configService.getConfigData().tab.event.add) || (tab.subTypeDetail.status.status === 'blank')) {
                tab.subTypeDetail.status.status = 'refresh';
            }
        }

        tab.type = 'Terminal';
        tab.subType = 'Status';


        if ('error' === tab.subTypeDetail.status.status) {
            tab.description = tab.description;
        } else {
            tab.description = tab.tabSearchParameter.searchText ? `${tab.tabSearchParameter.searchText} - ${tab.subType}` : tab.description;
        }

        if (tabType === this.configService.getConfigData().tab.event.add) {
            tab.id = route.params['tabid'];
            if (tab.tabSearchParameter && !tab.tabSearchParameter.searchText) {
                this.lmsLoaderService.hideLoader();
            }
            return this.tabService.notifyChange(<LmsEventDetails>({
                type: tabType,
                data: tab
            }));
        } else {
            this.tabService.notifyChange(<LmsEventDetails>({
                type: tabType,
                data: tab
            }));
        }

        if (tab.tabSearchParameter && !tab.tabSearchParameter.searchText) {
            this.lmsLoaderService.hideLoader();
        }

        return this.tabService.getTabById(Math.abs(route.params['tabid']));
    }
}
